const initialState = {
    banners: []
  }
    
    export default function(state = initialState, action) {
      switch(action.type){
        case "BANNERS_INDEX":
          return { ...state,  banners: action.payload }
        default: {
              return state
          }
      }
    }
    